// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/InventoryVarianceEntry.yaml
// Generated: 2026-03-11T13:04:51.084Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { InventoryVarianceEntry } from '@/types/inventory/InventoryVarianceEntry';

/**
 * InventoryVarianceEntry Service (Read-Only)
 * Query operations for InventoryVarianceEntry via the ABP API.
 */
export const inventoryVarianceEntryService = new ReadOnlyEntityService<InventoryVarianceEntry>(
  '/api/inventory/inventoryvarianceentry',
  'InventoryVarianceEntry',
);
